








































import {
    defineComponent,
    reactive,
    toRefs,
    computed,
    ref,
    Ref,
    PropType,
    watch,
} from '@vue/composition-api';
import Vue from 'vue';
import { intervalToDuration } from 'date-fns';
import { ChartSeriesType, LinkageParamType } from '../type';

export default defineComponent({
    props: {
        linkage: {
            type: Object as PropType<LinkageParamType>,
            required: true,
        },
        timeLabel: {
            // 本月  本季度  本年
            type: String,
            required: true,
        },
        timeShowType: {
            // 按天  按月 按季度
            type: String,
            required: true,
            default: 'month',
        },
        isGameTab: {
            type: Boolean,
            default: false
        },
        dataLen: {
            type: Number,
            required: true,
            default: 0,
        },
        dimensionUnion: {
            type: Boolean,
            default: true,
        },
    },

    setup(props, context) {
        const isShowLabel = ref(false);
        const timeOptions: Ref<Array<any>> = ref([]);

        function selectWay(way: string) {
            if (props.timeShowType === way) {
                return;
            }
            context.emit('update:timeShowType', way);
            context.emit('show-way', way);
        }

        const inputVal = computed({
            get: () => {
                return props.timeShowType;
            },
            set: (val) => {
                selectWay(val);
            },
        });

        function showDataLabel() {
            context.emit('show-data-label', isShowLabel.value);
        }

        function refreshTimeOptions() {
            const interval: Record<string, any> = intervalToDuration({
                start: props.linkage.dateRange[0],
                end: props.linkage.dateRange[1],
            });
            if (!props.dimensionUnion && props.dimensionUnion !== undefined) {
                timeOptions.value = [
                    {
                        title: '按天',
                        caption: 'day',
                    },
                ];
                return;
            }
            // 产品改动 自定义时间限制在一年以内 所以这个 interval.years! > 0 不会执行到，先留着
            if (props.timeLabel === 'year' || interval.years > 0) {
                timeOptions.value = [
                    {
                        title: '按月',
                        caption: 'month',
                    },
                    {
                        title: '按季度',
                        caption: 'quarter',
                    },
                ];
            } else if (props.timeLabel === 'quarter' || interval.months > 2) {
                timeOptions.value = [
                    {
                        title: '按月',
                        caption: 'month',
                    },
                ];
            } else {
                timeOptions.value = [
                    {
                        title: '按天',
                        caption: 'day',
                    },
                ];
            }
        }

        watch(
            () => props.linkage.dateRange,
            () => {
                refreshTimeOptions();
            },
            { immediate: true },
        );
        return {
            isShowLabel,
            selectWay,
            showDataLabel,
            timeOptions,
            inputVal,
        };
    },
});
